import styled from 'styled-components';
import Modal from '@iso/components/Feedback/Modal';
import WithDirection from '@iso/lib/helpers/rtl';

const EntraSsoModalWrapper = styled(Modal)`
  .ant-modal-body{
    padding: 12px 24px 12px 24px;
  }
  .btn-success{
    background-color: #0B2A1B;
    border-color: #0B2A1B;
  }
  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) .ant-select-item-option-state{
    color: #fff !important;
  }
  .switch-row{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    border-top: 1px solid #f0f0f0;
  }
  .switch-row .switch-label{
    font-weight: 500;
  }
`;

export default WithDirection(EntraSsoModalWrapper);
